
  
  
  import FETCHING from '../../library/fetching'
  import DATAMASTER from '../../library/dataMaster'
  import UMUM from '../../library/umum'
  
  export default {
    data() {
      return {
  
        form : {
          id : '',
          tahun : '',
          jml_potong : '',
          jml_setor : '',
          sisa : '',
          tahun : '',
          des_kel_id : '',
          nama_des_kel : '',
          file : null,
            file_type : '',
             file_old : null,
        },

        tahun: [
				      { id: '', tahun: 'Pilih Tahun'},
				      { id: 2021, tahun: '2021'},
				      { id: 2022, tahun: '2022'},
				      { id: 2023, tahun: '2023'},
				      { id: 2024, tahun: '2024'},
				      { id: 2025, tahun: '2025'},
				      { id: 2026, tahun: '2026'},
		    ],
  
        // ====================================== CONTOH AUTOCOMPLETE ====================================
        autocomplete_db : '',
        // ====================================== CONTOH AUTOCOMPLETE ====================================
        
        filterku : {
            tahun : '',
            des_kel_id : '',
            kecamatan_id : '',
        },

        file_path: this.$store.state.url.URL_APP + "uploads/",

        tipeku: null,
        UMUM : UMUM,


        mdl_open : false,

  
  
       
        list_data : [],
  
        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
        cek_load_data : true,
  
        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        btn_add: false,
  
  
        FETCHING : FETCHING,
        DATAMASTER : DATAMASTER,
      }
    },
    methods: {
  
  
      getView : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_BUKU + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                page_limit : this.page_limit,
                kecamatan_id : this.filterku.kecamatan_id,
                des_kel_id : this.filterku.des_kel_id,
                tahun : this.filterku.tahun,
                tipeku : this.tipeku,
            })
        })
            .then(res => res.json())
            .then(res_data => {
              console.log(res_data.data);
              
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.$store.commit("hideLoading");
                console.log(list_data);
        });
      },
  
  
      addData: function(){
  
  var formData = new FormData();
  formData.append('pb', JSON.stringify(this.form));
  formData.append('file', this.form.file);

  fetch(this.$store.state.url.URL_BUKU + 'addData', {
      method: "POST",
      headers: {
          authorization: "kikensbatara " + localStorage.token
      },
      body: formData
      }).then(res_data => {
        this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
        this.getView();
  });
  },
  
  
      editData : function(){
        fetch(this.$store.state.url.URL_BUKU + "editData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
        });
      },
  
      removeData : function(E){
        fetch(this.$store.state.url.URL_BUKU + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : this.form.id})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
        });
  
      },
  
      selectData : function(data){

        console.log(data);
          this.form.id = data.id;
          this.form.tahun = data.tahun;
          this.form.jml_potong = data.jml_potong;
          this.form.jml_setor = data.jml_setor;
          this.form.sisa = data.sisa;
          this.form.des_kel_id = data.des_kel_id;
          this.form.nama_des_kel = data.nama_des_kel;
          this.form.file_old =  data.file
          this.form.file = this.form.file
      },
  
  
      // ====================================== CONTOH eDOC ====================================
      async onChangexKecamatan(){
        
        
        await DATAMASTER.getKecamatanAsync("");
        this.onChangexDeskel();
      },
      async onChangexDeskel(){
        // console.log("yyyyyyyyyyyy");
        var deskelx = await DATAMASTER.getDeskelAsync(this.filterku.kecamatan_id)
        // console.log("xxxxxxxxxxxxx");
        console.log(deskelx[0].id);
      
          // this.filterku.des_kel_id = deskelx[0].id
        
        
        // console.log("xxxxxxxxxxxxx");
        console.log(this.filterku.des_kel_id);
        this.getView();
      },

      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },

            indexing : function(index){
                var idx = ((this.page_first-1)*this.page_limit)+index
                return idx
            },
  
  
      // ====================================== PAGINATE ====================================
  
  
  
  
  
  
  
    },
  
    mounted () {

      let profilex = JSON.parse(localStorage.profile);
      let profile = profilex.profile;
      DATAMASTER.getDeskelAsync(this.filterku.des_kel_id);
      this.form.des_kel_id = profile.des_kel_id;
      this.filterku.kecamatan_id = profile.kecamatan_id;
      this.filterku.des_kel_id = profile.des_kel_id;
      this.tipeku = profile.menu_klp;
      this.form.nama_des_kel = profile.nama_des_kel;

      console.log("======" + this.filterku.des_kel_id);
      

      const d = new Date();
      let year = d.getFullYear();
      this.form.tahun = year;
      this.filterku.tahun = year;

      console.log(profile)


      DATAMASTER.getTahun();


      this.onChangexKecamatan();

    },
  }
  